// extracted by mini-css-extract-plugin
export default {"modal":"Styles_modal__dkJzi","modal_header":"Styles_modal_header__Q8rbj","modal_body":"Styles_modal_body__BZ0Mj","input":"Styles_input__AmQV8","disabled":"Styles_disabled__TuC0+"};